import React from "react";
import "./App.css";

import { BrowserRouter, Route, Redirect, Switch, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import ContextMenu from "react-context-menu";

import rgbHex from 'rgb-hex';
import hexRgb from 'hex-rgb';

import "./assets/css/stack-interface.css";
import "./assets/css/socicon.css";
import "./assets/css/iconsmind.css";
import "./assets/css/font-awesome.css";
import "./assets/css/bootstrap.css";
import "./assets/css/lightbox.min.css";
import "./assets/css/flickity.css";
import "./assets/css/stack-interface.css";
import "./assets/css/theme.css";
import "./assets/css/grapick.min.css";
import "./assets/icons/plugins/flaticon2/flaticon.css";
import "./assets/css/aos.css";
import "./assets/css/custom.css";
import "./assets/scss/app.scss";

import "./constants/Api";
import "./constants/General";

import Menu from "./components/Menu";
import Footer from "./components/Footer";
import Page from "./components/Page";
import WebsiteloadingPlaceholder from "./components/WebsiteloadingPlaceholder";

import PasswordModal from "./components/modal/PasswordModal";
import WebsiteModal from "./components/modal/WebsiteModal";
import ShareModal from "./components/modal/ShareModal";

import General from "./utils/General";
import Backend from "./utils/Backend";
import CartUtil from "./utils/Cart";
import Notify from "./utils/Notify";
import AuthManager from "./utils/AuthManager";
import Navigation from "./utils/Navigation";

import Fonts from "./utils/Fonts";
import Event from "./utils/Event";

import Product from "./pages/Product";
import Onboarding from "./pages/Onboarding";
import Shop from "./pages/Shop";
import Booking from "./pages/Booking";
import Bookings from "./pages/Bookings";
import Checkout from "./pages/Checkout";
import Cart from "./pages/Cart";
import Article from "./pages/Article";
import Blog from "./pages/Blog";
import Package from "./pages/Package";
import NotFound from "./pages/NotFound";
import DataDetail from "./pages/DataDetail";

import TagManager from "react-gtm-module";
import Color from "./utils/Color";

import ColorScheme from "color-scheme"
import Website from "./utils/Website";
import InnerHTML from "dangerously-set-html-content";
import Currency from "./utils/Currency";
import ScriptCache from './utils/ScriptCache'
import SafeHtml from "./components/SafeHtml";
import { getDeviceType, storefrontPopupDeviceTypesCollection, subAndSaveEventName, subAndSaveTrigger } from "./components/constants/storefrontPopupConstants";
import { ccDevicePreviewDockPositionSessionKey, ccCurrentSelectedPreviewDevice } from "./constants/General";
import ProductStore from "./utils/ProductStore";


toast.configure();

window.FIXED_COLORS = ['transparent', 'rgba(255,255,255,1)', 'rgba(239,239,239,1)', 'rgba(51,51,51,1)']

window.MSC_COLORS = ['rgba(250,97,96,1)', 'rgba(230,145,56,1)', 'rgba(255,209,65,1)', 'rgba(106,168,79,1)', 'rgba(61,133,198,1)', 'rgba(103,78,167,1)', 'rgba(222,57,118,1)', 'rgba(239,239,239,1)', 'rgba(51,51,51,1)',]
window.MSC_COMPLIMENTARY_COLOURS = [...window.MSC_COLORS, ...window.FIXED_COLORS]

const MSC_COMPLIMENTARY_COLOURS_ENABLED = true

const DEVICE_PREVIEW_DOCK_POSITIONS = ["Top Left", "Top Right", "Bottom Left", "Bottom Right"]

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      currencyUpdated: false,
      deviceType: getDeviceType(window.innerWidth),
      previewSelectedDevice: localStorage.getItem(ccCurrentSelectedPreviewDevice) || props.selectedDevice || storefrontPopupDeviceTypesCollection[0].device,
      devicePreviewDockPosition: localStorage.getItem(ccDevicePreviewDockPositionSessionKey) || DEVICE_PREVIEW_DOCK_POSITIONS[0]
    };

    this.menu = React.createRef();
    this.footer = React.createRef();
    this.page = React.createRef();
    this.shop = React.createRef();
    this.booking = React.createRef();
    this.bookings = React.createRef();
    this.product = React.createRef();
    this.product2 = React.createRef();
    this.checkout = React.createRef();
    this.cart = React.createRef();
    this.article = React.createRef();
    this.blog = React.createRef();
    this.package = React.createRef();
    this.data = React.createRef();

    this.rightClickMenu = React.createRef();
    this.geoInterval = null
    this.geoSearchTimeout = null;
    this.indexjsTimerId = null;
  }

  handleResize = () => {
    const newDeviceType = getDeviceType(window.innerWidth)
    if (newDeviceType !== this.state.deviceType) {
      this.setState({ deviceType: newDeviceType })
    }
  };

  trackBreadcrumbTrail = () => {
    const { pathname } = this.props.location;

    let trail = JSON.parse(sessionStorage.getItem("breadcrumbTrail") || "[]");
    const existingIndex = trail.findIndex(entry => entry.url === pathname);

    let newTrail;

    if (existingIndex !== -1) {
      newTrail = trail.slice(0, existingIndex + 1);
    } else {
      let currentIndex = parseInt(sessionStorage.getItem("breadcrumbTrailIndex") || trail.length - 1);
      newTrail = trail.slice(0, currentIndex + 1);
      newTrail.push({ label: pathname, url: pathname });
    }
    const MAX = 5;
    if (newTrail.length > MAX) {
      const overflow = newTrail.length - MAX;
      newTrail = newTrail.slice(overflow);
    }
    sessionStorage.setItem("breadcrumbTrail", JSON.stringify(newTrail));
    sessionStorage.setItem("breadcrumbTrailIndex", newTrail.length - 1);
  };


  componentDidMount() {
    this._setup();
    Event.on('SHOW_NOTICE_BANNER', () => this.setState({
      showTrialExpired: true
    }));

    Event.on('WEBSITE_CHANGE_UPDATED', (website) => {
      this._setupWebsite(website, true)
      this.setState({
        website,
        eventUpdatedId: General.uuid(),
      })
      Event.emit("RELAYOUT_PAGE")
    });

    Event.on('PAGE_UPDATED', (page) => this.setState({
      page
    }));
    this.trackBreadcrumbTrail();
    if (window.top) {
      window.top.addEventListener('resize', this.handleResize);
    } else {
      window.addEventListener('resize', this.handleResize);
    }

    if (window?.top?.document) {
      const element = window.top.document.getElementsByClassName(`storefront-devices-preview-icon-box-main-${this.state.previewSelectedDevice}`)[0]
      element && element.click()
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.trackBreadcrumbTrail();
    }
  }

  componentWillUnmount() {
    if (this.geoInterval) {
      clearInterval(this.geoInterval)
    }
    if (this.geoSearchTimeout) {
      clearTimeout(this.geoSearchTimeout)
    }
    if (this.indexjsTimerId) {
      clearInterval(this.indexjsTimerId);
    }
    if (window.top) {
      window.top.removeEventListener('resize', this.handleResize)
    } else {
      window.removeEventListener('resize', this.handleResize)
    }
  }

  _updateComplimentaryColors(baseColor){
    if(!MSC_COMPLIMENTARY_COLOURS_ENABLED || !baseColor){
      return
    }

    let localHexBaseColor = baseColor.replace("#", "")
    if(!baseColor.startsWith("#")){
      let localBaseColor = baseColor.replace('rgba(', '').replace(')', '')
      localHexBaseColor = rgbHex(localBaseColor)
    }

    if(localHexBaseColor.length > 6){
      localHexBaseColor = localHexBaseColor.slice(0, -2)
    }

    var scheme = new ColorScheme;
    scheme.from_hue(0).from_hex(localHexBaseColor).scheme('tetrade').distance(0.83)

    var tetradeColors = scheme.colors().map(color => {
      let rgbValue = hexRgb(color)
      return `rgba(${rgbValue.red},${rgbValue.green},${rgbValue.blue},${rgbValue.alpha})`
    });

    let colors = [
      tetradeColors[3],
      tetradeColors[5],
      tetradeColors[9],
      tetradeColors[12],
    ]

    scheme.from_hue(0).from_hex(localHexBaseColor).scheme('triade').distance(0.83)

    let complimentaryColors = scheme.colors().map(color => {
      let rgbValue = hexRgb(color)
      return `rgba(${rgbValue.red},${rgbValue.green},${rgbValue.blue},${rgbValue.alpha})`
    });

    if(tetradeColors.includes("rgba(255,255,255,1)")){
      window.MSC_COMPLIMENTARY_COLOURS = ['rgba(250,97,96,1)', 'rgba(230,145,56,1)', 'rgba(255,209,65,1)','rgba(106,168,79,1)', 'rgba(61,133,198,1)', 'rgba(103,78,167,1)', 'transparent', 'rgba(239,239,239,1)', 'rgba(51,51,51,1)']
      return
    }

    colors = [
      colors[0],
      complimentaryColors[11],
      colors[1],
      colors[2],
      colors[3],
      ...window.FIXED_COLORS
    ]

    window.MSC_COMPLIMENTARY_COLOURS = colors
  }

  _authenticate() {
    this.setState({ showPasswordModal: true });
  }

  _closeRightClickMenu() {
    this.rightClickMenu && this.rightClickMenu.current && this.rightClickMenu.current.closeContextMenu();
  }

  _getRightClickMenuItems() {
    let { editable } = this.state;

    let contextItems = [
      {
        label: "Menu",
        onClick: () => {},
      },
    ];

    contextItems.push({
      label: "Share",
      onClick: () => {
        this.setState({ showShareModal: true });
        this._closeRightClickMenu();
      },
    });

    if (!editable) {
      contextItems.push({
        label: "Login",
        onClick: () => {
          this.setState(
            {
              editable: true,
              falseEditable: true
            },
            () => this._authenticate()
          );
          this._closeRightClickMenu();
        },
      });
    }

    if (editable) {
      contextItems.push({
        label: "Logout",
        onClick: () => {
          AuthManager.removeCredentials();
          this.setState({ editable: false });
          this._closeRightClickMenu();
          window.top ? window.top.location.reload() : window.location.reload();
        },
      });
    }

    contextItems.push({
      label: "Close Menu",
      onClick: () => this._closeRightClickMenu(),
    });

    return contextItems;
  }

  _setTracking(website) {
    let { editable } = this.state;

    let gtmId = editable ? window.Api.GTMID : website.gtm_id;

    if (!website || !gtmId) {
      return;
    }

    const tagManagerArgs = {
      gtmId: editable ? window.Api.GTMID : website.gtm_id,
    };

    TagManager.initialize(tagManagerArgs);
  }

  _loadScript() {
    let {
      editable
    } = this.state

    let baseUrl = window.location.origin;
    let pathname = '';

    if(Website.hasFunnelReference()){
      pathname = window.location.pathname.split('/')[1] + '/'
    }

    const script = document.createElement('script');
    script.src = `${baseUrl}/${pathname}index.js`; // Change to your remote file URL
    script.async = true;

    script.onload = () => {
      let obj = {}
      this.setState({indexLoaded: true, ...obj}, () => General.updateAll())
    };

    if(!editable){
      ScriptCache.loadDefaults()
      this.indexjsTimerId = setInterval(() => {
        if (typeof window?.jQuery !== "undefined") {
          clearInterval(this.indexjsTimerId);
          document.body.appendChild(script);
        }
      }, 50);
    }

    setTimeout(() => {
      General.updateAll()
    }, 500)
  }

  _setPageData(website) {
    let {
      editable
    } = this.state

    const script = document.createElement('script');
    script.id = "pageDataScript";
    script.text = `var pageData = {pageViewReferenceId: "${website.page_view_reference_id}", funnelReferenceId: "${website.funnel_reference_id}"};`

    if(!editable){
      document.body.appendChild(script);
    }
  }

  _showSubscriptionModal(){
    let { website, editable } = this.state
    let { subscription, notice } = website

    if ((!notice?.active && !subscription?.payment_flow) || (subscription?.active && !notice?.active)) {
      return false;
    }

    let paymentFlow = subscription.payment_flow

    if((!paymentFlow.triggered && paymentFlow.type !== "post_sign_up") && !notice?.active){
      return false
    }

    if(!editable){
      return notice?.active || paymentFlow.delinquent_treatment === "display_warning"
    }

    return true
  }

  _isDev(){
    let websiteUrl = window.location.host;

    return websiteUrl.indexOf("herokuapp.com") > -1 ||
           websiteUrl.indexOf("localhost") > -1
  }

  async _getFunnelFonts() {
    try {
      return await Backend.getFunnelFonts()
    } catch (err) {
      return null
    }
  }

  _uploadAndLoadAdditionalFonts(funnelFonts) {
    if (funnelFonts?.length) {
      const storefrontFontsMap = {}
      window.FONTS && window.FONTS.forEach(font => {
        storefrontFontsMap[font.familyName] = true
      })
      funnelFonts.forEach(font => {
        if (!storefrontFontsMap[font.fontFamily]) {
          Fonts.addUploaded({
            family_name: font.fontFamily,
            url: font.fontUrl,
            custom_class: font.fontFamily.trim().toLowerCase().replace(/\s/g, "-")
          })
          storefrontFontsMap[font.fontFamily] = true
        }
      })
      Fonts.loadAll()
    }
  }

  _setStorefrontCurrency() {
    const geoLocatedCountry = sessionStorage.getItem("ccGeoLocationCountry");
    const searchCurrencyCode = sessionStorage.getItem("currencyCode") || window?.CURRENT_CAMPAIGN?.countries?.find((o) => {
      return o.countryCode === geoLocatedCountry
    })?.currencyCode
    Currency.setCurrencyObject(searchCurrencyCode)
      .then(() => {
        this.setState({
          currencyUpdated: !this.state.currencyUpdated
        })
      })
  }

  async _setup(retry = true) {
    let websiteUrl = `${window.location.host}${window.location.pathname}`;
    let pathname = window.location.pathname;

    if (this._isDev()) {
      let funnelId = window.General.TestFunnelUrl.split("/")[1]
      websiteUrl = window.General.TestFunnelUrl;
      pathname = `/${funnelId}${pathname}`
      if(General.getUrlParameter('website')){
        websiteUrl = General.getUrlParameter('website');
      }
    } else if (window.location.protocol !== "https:") {
      window.location.replace(
        `https:${window.location.href.substring(
          window.location.protocol.length
        )}`
      );
    }

    let pageSlug = null;
    let productSlug = null;

    let cartMode = false;
    let productMode = false;
    let collectionMode = false;
    let onBoardingMode = false;

    let editable = false;
    let show404 = false;

    let data = {};
    try {
      data = await Backend.findWebsite(
        websiteUrl,
        pathname,
      );
      editable = data.editable;
      AuthManager.currentUser = data.current_user;

      cartMode = data.cart_mode
      pageSlug = data.page_slug
      productMode = data.product_mode
      collectionMode = data.collection_mode
      onBoardingMode = data.onboarding_mode

      if (pageSlug && !data.page) {
        show404 = true;
      }
    } catch (error) {
      console.error("Unexpected Error: ", error);
      AuthManager.removeCredentials();
      if (retry) {
        this._setup(false);
        return;
      }
      this.setState({ show404: true, loading: false });
      return;
    }

    if (!data.editable && !data.website){
      this.setState({ show404: true, loading: false, underConstruction: true });
      return;
    }

    this._updateComplimentaryColors(data.website.primary_color)

    let cart = CartUtil.init();
    window.CURRENT_WEBSITE_SHOP_CURRENCY = ""
    window.WEBSITE_VERSION_ID = data.version_id

    if (data.website) {
      this._setupWebsite(data.website, data.editable);
      window.CURRENT_VISITOR_TOKEN = data.visitor_token;
    }

    if (data.page) {
      window.CURRENT_PAGE_SLUG = data.page.slug;
      window.CURRENT_PAGE_ID = data.page.id;
    }

    if (data.uploaded_fonts) {
      for (let i = 0; i < data.uploaded_fonts.length; i++) {
        let font = data.uploaded_fonts[i];
        Fonts.addUploaded(font);
      }
      Fonts.loadAll();
    }

    await Backend.getCampaignInfo(data.website)
      .then(() => {
        this._setStorefrontCurrency()
        if (editable) {
          Backend.getGeoLocationInfo()
            .then(async () => {
              this._setStorefrontCurrency()
            })
        } else {
          this.geoInterval = setInterval(() => {
            let storedData = sessionStorage.getItem("ccGeoLocationInfo")
            if (storedData) {
              storedData = JSON.parse(storedData)
              sessionStorage.setItem("ccGeoLocationCountry", storedData?.country_code || "")
              clearInterval(this.geoInterval)
              this._setStorefrontCurrency()
            }
          }, 500)
          this.geoSearchTimeout = setTimeout(() => {
            clearInterval(this.geoInterval)
          }, 1000);
        }
      }).catch(() => {
        this._setStorefrontCurrency()
      })
    
    await ProductStore.fetchPageProducts(data)

    if (editable) {
      const funnelFonts = await this._getFunnelFonts()
      this._uploadAndLoadAdditionalFonts(funnelFonts)
      window.FUNNEL_FONTS_URLS_OBJ = {};
      funnelFonts && funnelFonts.forEach(font => {
        window.FUNNEL_FONTS_URLS_OBJ[font.fontFamily] = font.fontUrl
      })
    } else if (data?.website) {
      const tags = ["h1", "h2", "h3", "h4", "h5", "h6", "menu", "btn", "p", "primary_logo", "secondary_logo"], fontsArray = [];
      tags.forEach((tag) => {
        let obj = data.website[tag + "_font"]
        if (["primary_logo", "secondary_logo"].includes(tag)) {
          obj = data.website[tag]?.["font"]
        }
        if (obj && obj.url) {
          fontsArray.push({
            "fontFamily": obj.family_name,
            "fontUrl": obj.url
          })
        }
      })
      this._uploadAndLoadAdditionalFonts(fontsArray);
    }

    this.setState(
      {
        cart,
        show404,
        websiteUrl,
        pageSlug,
        cartMode,
        productMode,
        collectionMode,
        onBoardingMode,
        productSlug,
        menu: data.menu,
        footer: data.footer,
        page: data.page,
        website: data.website,
        loading: false,
        canRenderContent: this.props.canRenderContent,
        showPasswordModal: data.password !== "valid",
        passwordError:
          data.password === "invalid"
            ? "Password is incorrect, please try again"
            : null,
        showCustomModal: false,
        canAnimate: false,
        animatingContentBlockKey: null,
        editable,
      },
      () => {
        this._loadScript()
        this._setTracking(data.website)
        this._setPageData(data.website)

        if(this._showSubscriptionModal()){
          window.addEventListener('scroll', function() {
            if (window.scrollY >= window.innerHeight*.5) {
              if(editable){
                Event.emit("SHOW_SUBSCRIPTION_MODAL");
              }else{
                Event.emit("SHOW_NOTICE_BANNER");
              }
            }
          });
        }

      }
    );
  }

  _setupWebsite(website, editable = true){
    if (website) {
      window.SHOW_HIDDEN_BLOCKS = false
      window.HAS_HIDDEN_BLOCKS = false
      window.FIRST_HIDDEN_BLOCKS = false
      window.IS_EDIT_MODE = editable;
      window.CURRENT_WEBSITE = website;
      window.CURRENT_WEBSITE_ID = website.id;
      window.CURRENT_PAGE_PRIMARY_COLOR = website.primary_color;
      window.CURRENT_PAGE_SECONDARY_COLOR = website.secondary_color;
      window.CURRENT_PAGE_PREVIEW = website.preview_image;
      window.CURRENT_PAGE_PRIMARY_COLOR_DARKENED = Color.brightness(
        window.CURRENT_PAGE_PRIMARY_COLOR,
        -20
      );
      window.CURRENT_COMPANY_ID = website.company_id;
      window.HIDE_CART = false
      window.CURRENT_WEBSITE_DESIGN_STYLE = website.design_style;
      window.IS_CARD_STYLE_WEBSITE = window.CURRENT_WEBSITE_DESIGN_STYLE === "card"
      if(!website.background_color){
        website.background_color = '#dfdfdf'
      }
      window.CURRENT_WEBSITE_BACKGROUND_COLOR = website.background_color;
    }
  }

  _updateWebsite = General.debounce(
    (website) => {
      this._updateComplimentaryColors(website.primary_color)
      this.setState({ website });
      Backend.updateWebsite(website);
    },
    1000,
    false
  );

  _renderPasswordModal() {
    let { loading, editable, websiteUrl, passwordError, showPasswordModal } =
      this.state;

    return (
      <PasswordModal
        show={showPasswordModal}
        edit={editable}
        loading={loading}
        error={passwordError}
        websiteUrl={websiteUrl}
        onHide={() =>
          this.setState({
            showPasswordModal: false,
            editable: false
          }, () => {
            setTimeout(() => General.updateAll(), 1000)
          })
        }
        onLoggedIn={() => {
          window.top ? window.top.location.reload() : window.location.reload()
        }}
      />
    );
  }

  _renderAllFonts() {
    let fontHTML = "";
    window.FONTS.map((font) => {
      if (font.url) {
        fontHTML += `
          @font-face {
            font-family: "${font.familyName}";
            src: url('${font.url}');
          }
        `;
      }

      fontHTML += `
        .${font.className} {
          font-family: "${font.familyName}";
        }
      `;
      font.weights.map((weight) => {
        fontHTML += `
          .${font.className}-${weight.value} {
            font-weight: ${weight.value};
          }
        `;
      });
    });
    return <style dangerouslySetInnerHTML={{ __html: fontHTML }} />;
  }

  _renderTrialExpires() {
    let { website } = this.state
    let { subscription } = website
    let { notice } = website

    let title = "Website Under Maintenance"
    if(notice?.active && notice?.text){
      title = notice.text
    }
    else if(subscription.payment_flow.visitor_title){
      title = subscription.payment_flow.visitor_title
    }

    let textColor = '#fff'
    let backgroundColor = window.CURRENT_PAGE_PRIMARY_COLOR

    if(notice?.active && notice?.text_color){
      textColor = notice.text_color
    }

    if(notice?.active && notice?.background_color){
      backgroundColor = notice.background_color
    }


    return (
      <>
        <div className="trial-expires main-container">
          <h1
            className="banner-h1"
            style={{
              color: textColor
            }}
          >{title}</h1>
        </div>
        <style
          dangerouslySetInnerHTML={{
            __html: `
              .trial-expires.main-container::before{
                background-color : ${backgroundColor};
              }
            `,
          }}
        />
      </>
    );
  }

  _renderWebsiteFonts() {
    let { website } = this.state;

    if (!website) {
      return null;
    }

    let websiteFonts = [];

    let tags = ["h1", "h2", "h3", "h4", "h5", "h6", "btn", "menu", "p"];

    for (var i = 0; i < tags.length; i++) {
      let tag = tags[i];
      let fontKey = tag + "_font";

      if (website[fontKey]) {
        let font = website[fontKey];

        if (tag === "menu") {
          websiteFonts.push(this._getFontStyle("a", font, true));
          websiteFonts.push(this._getFontStyle("h5", font, true));
          websiteFonts.push(this._getFontStyle("span", font, true));
        } else {
          websiteFonts.push(this._getFontStyle(tag, font));
        }

        if (tag === "btn") {
          websiteFonts.push(this._getFontStyle(tag, font, true));
        }

        if (tag === "p") {
          websiteFonts.push(
            this._getFontStyle("span:not([class^='h''])", font)
          );
        }

        if (tag === "h2") {
          websiteFonts = this._addSubHeaderFonts(websiteFonts, font, website);
        }
      }
    }

    return (
      <style dangerouslySetInnerHTML={{ __html: websiteFonts.join("") }} />
    );
  }

  _addSubHeaderFonts(websiteFonts, font, website) {
    // set h2 as the font and weight for other headers if none specified
    let headers = ["h3", "h4", "h5", "h6"];
    for (var i = 0; i < headers.length; i++) {
      let header = headers[i];
      let headerKey = header + "_font";
      let headerFont = website[headerKey];
      if (!headerFont || Object.keys(headerFont).length === 0) {
        websiteFonts.push(this._getFontStyle(header, font));
      }
    }

    return websiteFonts;
  }

  _getFontStyle(tag, font, menu = false) {
    if (!font || font.family_name == null) {
      return null;
    }

    let excludes =
      ":not(.boxed):not(.ignore-user-set-font):not(.render-preview-image)";
    let selector = `
      .main-container ${tag},
      .main-container .${tag}
    `;

    if (menu) {
      selector = `
        .nav-container ${tag}:not(.material-icons):not(.material-icons-two-tone):not(.logo-text):not(.slide-text),
        .nav-container .${tag}:not(.material-icons):not(.logo-text):not(.slide-text),
        footer ${tag}:not(.material-icons):not(.logo-text),
        footer .${tag}:not(.material-icons):not(.logo-text)
      `;
    }

    return `
      ${selector} {
        font-family: "${font.family_name}" !important;
        font-weight: ${font.weight} !important;
      }
    `;
  }

  _onAddToCartPressed(product, variant, customMessage, quantity, frequency) {
    const subAndSavePopupExists = this.state?.website?.extra?.popup_collection?.find((o) => o.trigger === subAndSaveTrigger);
    if (subAndSavePopupExists) {
      if (product.recurringProductId) {
        Backend.getProducts(product.recurringProductId).then(subscribeAndSaveProducts => {
          let subscribeAndSaveProduct = subscribeAndSaveProducts[0]
          if (subscribeAndSaveProduct) {
            const details = { product, variant, customMessage, quantity, frequency, subscribeAndSaveProduct }
            const customEvent = new CustomEvent(subAndSaveEventName, {
              detail: details
            })
            window.dispatchEvent(customEvent)
          }
        })
      }
    }
    CartUtil.add(product, variant, customMessage, quantity, frequency)
      .then((cart) => {
        let productPageSettings = this.state.website.extra?.product_page_settings
        if(window.CURRENT_WEBSITE.checkout_type === "instant" || window.CURRENT_WEBSITE.checkout_type === "instantAndBuy"){
          if(window.IS_EDIT_MODE){
            Notify.error("Checkout disabled in edit mode")
          }else if(productPageSettings?.checkout_url){
            General.setLocationHref(Navigation.getUrl(productPageSettings?.checkout_url))
          }else{
            Notify.error("Checkout url not set, please contact the site owner")
          }
          return
        }
        this.menu.current.updateCart(cart);
        this.menu.current.showCartDropdown();
        this.setState({ cart });
      })
      .catch((error) => {
        Notify.error(error.message);
      });
  }

  _renderDefaultButtonStyles() {
    let { page, website } = this.state;
    if (page == null && website == null) {
      return null;
    }

    if (!website) {
      website = page.website;
    }

    website = { ...website };
    website.primary_btn_color = website.primary_color;
    website.secondary_btn_color = website.primary_color;

    let buttonBorderRadius = "6px";
    if (website.button_style === "rounded") {
      buttonBorderRadius = "50px";
    }

    if (website.button_style === "square") {
      buttonBorderRadius = "0px";
    }

    let editorBrandingColor = "#333333"
    if(!website.editor_branding_mode || website.editor_branding_mode === "company"){
      editorBrandingColor = website.primary_btn_color
    }
    else if(website.editor_branding_mode == "platform"){

    }

    return (
      <style
        dangerouslySetInnerHTML={{
          __html: `
          :root {
            --website-primary-color: ` + website.primary_color + ` ;
            --website-primary-color-darkened: ` + window.CURRENT_PAGE_PRIMARY_COLOR_DARKENED + ` ;
            --website-primary-color-o-10: ` + Color.addAlpha(website.primary_color, '1A') + ` ;
            --website-primary-color-o-30: ` + Color.addAlpha(website.primary_color, '4D') + ` ;
            --website-primary-color-o-90: ` + Color.addAlpha(website.primary_color, 'E6') + ` ;
            --website-primary-color-dark-10: ${Color.brightness(website.primary_color, -10)};
            --card-style-website-card-background-color: ` + window.CURRENT_WEBSITE_BACKGROUND_COLOR + ` ;
            --editorBrandingColor: ${Color.saturate(Color.brightness(editorBrandingColor, -40, "50"), 10)};
            --editorBrandingHoverColor: ${Color.saturate(Color.brightness(editorBrandingColor, -60, "80"), 10)};
          }
          .primary-color-swatch > div {
            background-color: ${website.primary_color};
          }
          .product-sale-price {
            background-color: ${website.primary_btn_color} !important;
            border-color: ${website.primary_btn_color};
          }
          .product-sale-price-darken{
            background-color:transparent !important;
          }
          .product-sale-price-darken:after {
            filter: brightness(90%);
            content:"";
            background-color: ${website.primary_btn_color} !important;
            border-color: ${website.primary_btn_color};
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-radius: 50px;
            z-index: -1;
          }
          .main-container a.btn--primary {
            background-color: ${website.primary_btn_color};
            border-color: ${website.primary_btn_color};
          }
          .main-container .btn--primary:hover {
            background-color: ${website.primary_btn_color};
          }
          .nav-container a.btn--primary {
            background-color: ${website.primary_btn_color};
            border-color: ${website.primary_btn_color};
          }
          a.nav-checkout svg path, .cart-icon-picker-color svg path {
            fill: ${website.primary_btn_color};
          }
          a.nav-checkout i, .cart-icon-picker-color {
            color: ${website.primary_btn_color};
          }
          .rdw-editor-wrapper:hover::after{
            background-color:${Color.brightness(website.primary_btn_color, 20, "60")} !important;
            border-color: ${Color.brightness(website.primary_btn_color, 20, "90")};
            border-radius: 0px;
          }
          .rdw-editor-wrapper .rdw-editor-toolbar {
            background-color: ${Color.saturate(Color.brightness(website.primary_btn_color, -20, "95"), 50)} !important;
          }
          .rdw-editor-wrapper .rdw-editor-toolbar:before{
            border-top-color: ${Color.saturate(Color.brightness(website.primary_btn_color, -20, "95"), 50)} !important;
          }
          .rdw-link-modal {
            background-color: ${Color.saturate(Color.brightness(website.primary_btn_color, -20), 30)} !important;
          }
          .edit,
          .nav-button-edit a,
          .section .settings .buttons a,
          .btn-fixed-left-container .btn,
          .add-content-block + .add-content-block-button .button {
            background-color: ${Color.saturate(Color.brightness(editorBrandingColor, -40, "50"), 10)};
          }
          .section .settings .buttons a.unhide{
            background-color: ${Color.saturate(Color.brightness(editorBrandingColor, -10, "80"), 10)};
          }
          .section .settings .buttons a.unhide:hover{
            background-color: ${Color.saturate(Color.brightness(editorBrandingColor, -10, "80"), 10)};
          }
          .edit:hover,
          .nav-button-edit a:hover,
          .section .settings .buttons a:hover,
          .btn-fixed-left-container .btn:hover,
          .add-content-block + .add-content-block-button .button:hover {
            background-color: ${Color.saturate(Color.brightness(editorBrandingColor, -60, "80"), 10)};
          }
          a.link--primary,
          .text--primary,
          .articles .article-body a{
            color: ${website.primary_btn_color};
          }
          .bg-c-primary{
            background-color: ${website.primary_btn_color};
          }
          .page.product .slider-product-nav li.slide.is-selected{
            border-color: ${website.primary_btn_color};
          }
          .page.product .vertical-product-nav li.slide.is-selected{
            border-color: ${website.primary_btn_color};
          }
          .nav-container .btn--primary:hover {
            background-color: ${website.primary_btn_color};
          }
          .main-container .btn:not([class*='primary']),
          .main-container .btn:not([class*='primary']):hover,
          .main-container .imagebg:not(.image--light) .btn:not([class*='primary']),
          .main-container .imagebg:not(.image--light) .btn:not([class*='primary']):hover {
            border-color: ${website.secondary_btn_color};
          }
          .main-container .btn:not([class*='primary']) span,
          .main-container .imagebg:not(.image--light) .btn:not([class*='primary']) span {
            color: ${website.secondary_btn_color};
          }
          .nav-container .btn:not([class*='primary']),
          .nav-container .btn:not([class*='primary']):hover,
          .nav-container .imagebg:not(.image--light) .btn:not([class*='primary']),
          .nav-container .imagebg:not(.image--light) .btn:not([class*='primary']):hover {
            border-color: ${website.secondary_btn_color};
          }
          .nav-container .btn:not([class*='primary']) span,
          .nav-container .imagebg:not(.image--light) .btn:not([class*='primary']) span {
            color: ${website.secondary_btn_color};
          }
          @media (min-width: 991px){
            .bar--transparent:not(.bar--dark):not(.pos-fixed) .btn:not([class*='primary']),
            .bar--transparent:not(.bar--dark):not(.pos-fixed) .btn:not([class*='primary']):hover {
              border-color:  ${website.secondary_btn_color};
            }
            .bar--transparent:not(.bar--dark):not(.pos-fixed) .btn:not([class*='primary']) .btn__text {
              color: ${website.secondary_btn_color};
            }
          }
          .main-container  .btn:not(.btn-products):not(.skip) ,
          .nav-container .btn,
          .cookie-banner .btn {
            border-radius: ${buttonBorderRadius};
          }
          .btn.btn--icon i:not(.edit-button-i) {
            border-radius: ${buttonBorderRadius} 0 0 ${buttonBorderRadius} !important;
            color:inherit !important;
          }
          .rdp-day_selected,
          .rdp-day_selected:hover {
            background: ${website.primary_color};
          }
          .rdp-button:hover:not([disabled]):not(.rdp-day_selected){
            background: ${Color.brightness(website.primary_color, 20, "60")};
          }
          .rdp-day_today {
            font-weight: normal !important;
          }
          .async-select-paginate__option--is-selected,
          .async-select-paginate__option--is-focused {
            background: ${website.primary_color};
            color: white;
          }
          .async-select-paginate__option:hover {
            background: ${Color.brightness(website.primary_color, 20, "60")};
            color: white;
          }
          .async-select-paginate__control:hover,
          .async-select-paginate__control--is-focused,
          .async-select-paginate__control--is-selected {
            box-shadow: none;
            outline: none !important;
          }
        `,
        }}
      />
    );
  }

  _renderMainContent() {
    let {
      page,
      website,
      editable,
      cartMode,
      productMode,
      collectionMode,
      showPasswordModal,
      deviceType,
      previewSelectedDevice
    } = this.state;

    if (productMode) {
      return this._renderProductContent();
    }

    if (cartMode) {
      return this._renderCartContent();
    }

    if (collectionMode) {
      return this._renderCollectionContent();
    }

    return (
      <Page
        ref={this.page}
        editable={editable}
        page={page}
        website={website}
        canShowDashboardButtons={!showPasswordModal}
        onShowWebsiteModalPressed={() =>
          this.setState({ showWebsiteModal: true })
        }
        onAddToCartPressed={(
          product,
          variant,
          customMessage,
          quantity,
          frequency = null
        ) =>
          this._onAddToCartPressed(product, variant, customMessage, quantity, frequency)
        }
        deviceType={editable ? previewSelectedDevice : deviceType}
        onUpdatedCart={(cart) => this.setState({ cart })}
      />
    );
  }

  _renderCartContent() {
    let { cart, editable, website, page } = this.state;
    return (
      <BrowserRouter>
        <Switch>
          <Route
            exact
            path={window.location.pathname}
            render={(props) => {
              return (
                <Cart
                  ref={this.cart}
                  cart={cart}
                  page={page}
                  website={website}
                  editable={editable}
                  onAddToCartPressed={(
                    product,
                    variant,
                    customMessage,
                    quantity = 1,
                    frequency = null
                  ) => {
                    this._onAddToCartPressed(product, variant, customMessage, quantity, frequency);
                  }}
                  onUpdatedCart={(cart) => this.setState({ cart })}
                />
              );
            }}
          />
        </Switch>
      </BrowserRouter>
    );
  }

  _renderCollectionContent() {
    let { editable, website, collectionMode, page } = this.state;
    return (
      <BrowserRouter>
        <Switch>
          <Route
            path={window.location.pathname}
            render={(props) => {
              return (
                <Shop
                  ref={this.shop}
                  editable={editable}
                  website={website}
                  page={page}
                  collectionMode={collectionMode}
                  onAddToCartPressed={(
                    product,
                    variant,
                    customMessage,
                    quantity = 1,
                    frequency = null
                  ) => {
                    this._onAddToCartPressed(product, variant, customMessage, quantity, frequency);
                  }}
                  onUpdatedCart={(cart) => this.setState({ cart })}
                />
              )
            }}
          />
        </Switch>
      </BrowserRouter>
    );
  }

  _renderProductContent() {
    let { editable, page } = this.state;

    return (
      <Product
        ref={this.product}
        editable={editable}
        page={page}
        onAddToCartPressed={(
          product,
          variant = null,
          customMessage =null,
          quantity = 1,
          frequency = null
        ) => {
          this._onAddToCartPressed(product, variant, customMessage, quantity, frequency);
        }}
        productPage={true}
        onUpdatedCart={(cart) => this.setState({ cart })}
      />
    );
  }

  render() {
    let {
      website,
      editable,
      cart,
      page,
      menu,
      footer,
      cartMode,
      productMode,
      collectionMode,
      showWebsiteModal,
      showShareModal,
      onBoardingMode,
      show404,
      loading,
      showTrialExpired,
      showPasswordModal,
      underConstruction,
      showDevicePreviewDockPosition,
      devicePreviewDockPosition
    } = this.state;

    if (showPasswordModal) {
      return this._renderPasswordModal();
    }

    if (loading) {
      return (
        <WebsiteloadingPlaceholder
          shopMode={cartMode || collectionMode}
        />
      );
    }

    if (onBoardingMode) {
      return <Onboarding website={website} />;
    }

    if (show404) {
      return <NotFound website={website} underConstruction={underConstruction}/>;
    }

    return (
      <BrowserRouter>
        <head>
          {website.header_js && <SafeHtml html={website.header_js}/>}
        </head>
        <div className="main-template">
          <div className="main-template-header">
            <Menu
              ref={this.menu}
              editable={editable}
              menu={menu}
              cart={cart}
              page={page}
              website={website}
              hidePrimaryNavBar={cartMode || productMode || collectionMode}
              renderModal={(content) => this.page.current.renderModal(content)}
              onUpdatedCart={(cart) => this.setState({ cart })}
              onUpdateWebsite={(website) => {
                this._updateWebsite(website);
                this.menu.current.updateWebsite(website);
              }}
              onAddToCartPressed={(product, variant, customMessage, quantity = 1, frequency = null) => {
                this._onAddToCartPressed(product, variant, customMessage, quantity, frequency);
              }}
            />
          </div>
          <div className="main-template-content">
            {this._renderMainContent()}
          </div>
          <div className="main-template-footer">
            <Footer
              ref={this.footer}
              editable={editable}
              website={website}
              footer={footer}
              renderModal={(content) => this.page.current.renderModal(content)}
            />
          </div>
        </div>
        {this._renderAllFonts()}
        {this._renderWebsiteFonts()}
        {this._renderDefaultButtonStyles()}
        {
          website?.footer_js &&
          <SafeHtml style={{display: "none"}} html={website.footer_js}/>
        }
        <WebsiteModal
          show={showWebsiteModal}
          page={page}
          website={website}
          menu={menu}
          onUpdated={(website) => {
            this._updateWebsite(website);
            this.menu.current.updateWebsite(website);
          }}
          onMenuUpdated={(menu) => {
            this.menu.current.updateMenu(menu);
          }}
          onPageSoftUpdated={(page) => {
            this.setState({ page });
          }}
          onMenuSoftUpdated={(menu) => {
            this.menu.current.updateMenu(menu, false);
          }}
          onHide={() => this.setState({ showWebsiteModal: false })}
        />
        { (this._isDev() && page && document.getElementById('root')) && (
          <ContextMenu
            contextId="root"
            ref={this.rightClickMenu}
            items={this._getRightClickMenuItems()}
          />
        )}
        <ShareModal
          show={showShareModal}
          title="Share"
          message="Click below to share this site on various channels"
          shareTitle="Checkout This Site"
          url={window.location}
          onHide={() => this.setState({ showShareModal: false })}
          onAdded={() => this.setState({ showShareModal: false })}
        />
        {showTrialExpired && this._renderTrialExpires()}

        {editable && <div
            className={`storefront-devices-preview-icon-container ${(devicePreviewDockPosition).replace(" ", "-").toLowerCase()}`}
          >
          {storefrontPopupDeviceTypesCollection.map((v, index) => {
            return (
              <div
                key={index}
                className={`storefront-devices-preview-icon-box ${v.device === this.state.previewSelectedDevice ? "selected" : ""}`}
                onClick={() => {
                  if (window?.top?.document) {
                    const element = window.top.document.getElementsByClassName(`storefront-devices-preview-icon-box-main-${v.device}`)[0]
                    localStorage.setItem(ccCurrentSelectedPreviewDevice, v.device);
                    element && element.click()
                  }
                  this.setState({
                    previewSelectedDevice: v.device
                  })
                }}
                dangerouslySetInnerHTML={{ __html: v.svg }}
              ></div>
            )
          })}
          <div className="storefront-devices-preview-icon-action">
            <i
              className="material-icons"
              onClick={() => {
                this.setState((prevState) => ({
                  showDevicePreviewDockPosition: !prevState.showDevicePreviewDockPosition
                }))
              }}
            >more_vert</i>
            {
              showDevicePreviewDockPosition && <div className="storefront-devices-preview-icon-position-list">
                {
                  DEVICE_PREVIEW_DOCK_POSITIONS.map((item, index) => {
                    return <div
                        key={index}
                        onClick={() => {
                          localStorage.setItem(ccDevicePreviewDockPositionSessionKey, item)
                          this.setState({
                            devicePreviewDockPosition: item,
                            showDevicePreviewDockPosition: false
                          })
                        }}
                      >{item}</div>
                  })
                }
              </div>
            }
          </div>
        </div>}
      </BrowserRouter>
    );
  }
}
export default withRouter(App);
